import React, { useEffect, useState } from "react";

const Customform = ({
  fields,
  onSubmit,
  mode,
  initialData = {},
  imagePreviews,
  handleCustomerImageChange,
}) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (initialData) {
      const prefilledData = {};
      fields.forEach((field) => {
        prefilledData[field.name] = initialData[field.name] || "";
      });
      setFormData(prefilledData);
    }
  }, [initialData, fields]);



  const submitForm = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e, field) => {
    const { name, value, type, checked, files } = e.target;
  
    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else if (field.type === "select") {
      setFormData({
        ...formData,
        [name]: field.options.find((opt) => opt.value.toString() === value)
          .value,
      });
    } else if (field.type === "file") {
      // store file object in formData (optional for future use)
      setFormData({ ...formData, [name]: files });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  

  return (
    <form onSubmit={submitForm} className="space-y-4">
      {fields.map((field, index) => (
        <div key={index} className="flex flex-col gap-1">
          <label className="font-medium">{field.label}</label>

          {field.type === "select" ? (
            <select
              name={field.name}
              required={field.required}
              value={formData[field.name]}
              onChange={(e) => handleChange(e, field)}
              className="border px-2 py-1 rounded"
            >
              <option value="">Select {field.label}</option>
              {field.options.map((opt, idx) => (
                <option key={idx} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          ) : field.type === "file" ? (
            <>
              <input
                type="file"
                name={field.name}
                multiple={field.multiple}
                onChange={handleCustomerImageChange}
                className="border px-2 py-1 rounded"
              />
              <div className="flex flex-wrap gap-2 mt-2">
              
                  <img
                    key={imagePreviews}
                    src={imagePreviews}
                    alt="preview"
                    className="w-24 h-24 object-cover rounded"
                  />
            
              </div>
            </>
          ) : (
            <input
              type={field.type || "text"}
              name={field.name}
              placeholder={field.placeholder}
              required={field.required}
              value={formData[field.name]}
              onChange={(e) => handleChange(e, field)}
              className="border px-2 py-1 rounded"
            />
          )}
        </div>
      ))}

      <button
        type="submit"
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        {mode === "ADD" ? "Add" : "Update"}
      </button>
    </form>
  );
};

export default Customform;
